import * as React from 'react'
import axios from 'axios'
import { useLocale, useTranslation } from 'hooks'
import { csrfToken } from 'helpers'
import { ProductSaleItemActionProps } from './ProductSaleItem.types'

const ProductSaleItemAction: React.FC<ProductSaleItemActionProps> = ({
  action,
  className: _className = '',
  onDelete,
  onUpdate,
  ...props
}) => {
  const { t } = useTranslation()
  const { localiseUrl } = useLocale()

  const isDeleteAction = action.options?.data?.method === 'delete'

  const isUpdateAction = action.options?.data?.method === 'update'
  const el = React.useRef<HTMLAnchorElement>(null)

  const saveScrollPosition = () => {
    sessionStorage.setItem('sellingScrollPosition', String(window.scrollY))
  }

  const deleteRow = async (href: string) => {
    await axios.delete(localiseUrl(href, { localeAsParam: true }), {
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken
      }
    })

    saveScrollPosition()
    window.location.reload()
  }

  const updateProductPrice = async (id: string) => {
    await axios.patch(
      localiseUrl(`/api/selling/${id}/price`, { localeAsParam: true }),
      {
        authenticity_token: csrfToken
      }
    )

    if (onUpdate) {
      onUpdate()
    } else {
      saveScrollPosition()
      window.location.reload()
    }
  }

  const onClick = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (isDeleteAction) {
      e.preventDefault()
      if (action.options?.data?.confirm) {
        const confirmAction = confirm(action.options?.data?.confirm)

        if (!confirmAction) return
      }

      if (onDelete) {
        onDelete(action.href)
      } else {
        await deleteRow(action.href)
      }
    } else if (isUpdateAction) {
      e.preventDefault()
      const confirmAction = confirm(action.options?.data?.confirm)

      if (confirmAction && action.id) {
        await updateProductPrice(action.id)
      }
    } else {
      sessionStorage.setItem('sellingScrollPosition', String(window.scrollY))
    }
  }

  return (
    <a
      ref={el}
      key={action.label}
      href={localiseUrl(action.href)}
      target={action.options?.data?.target}
      data-testid={isDeleteAction ? 'list-item-sale-action-delete' : ''}
      onClick={(e) => onClick(e)}
      {...{
        disabled: action.options?.disabled
      }}
      {...props}
      className="btn btn--secondary btn--small"
    >
      {action.label}
      {action.options?.delete_icon && t('shared.delete')}
    </a>
  )
}

export default ProductSaleItemAction
